
import { Vue, Component, Prop } from "vue-property-decorator";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmIcon } from "@afe/amui/src/components/Icon";
@Component({
  components: {
    AmIcon,
    AmTypography
  }
})
export default class extends Vue {
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop(String) readonly facebook!: string;
  @Prop(String) readonly google!: string;
  @Prop(String) readonly title!: string;

  get classes() {
    return {
      "is-loading": this.loading
    };
  }
}
